"use strict";
/**
 * Created by fan on 1/16/17.
 */
exports.__esModule = true;
require('bootstrap/js/modal');
var schema_1 = require("../logic/schema");
var schema_fieldlist_1 = require("../logic/schema-fieldlist");
var schema_selector_1 = require("../logic/schema-selector");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var universal;
            (function (universal) {
                var schema;
                (function (schema_2) {
                    var plumbing;
                    (function (plumbing) {
                        angular.module('smartorg.r6.acts.universal.schema').directive("schemaBuilder", ["$timeout", function ($timeout) {
                                return {
                                    restrict: 'E',
                                    template: require('../../template/schema-builder.html'),
                                    scope: {
                                        smartorg: '='
                                    },
                                    link: function (scope) {
                                        // Initialize terminology with defaults
                                        scope.terminology = {
                                            Portfolio: 'Portfolio',
                                            portfolio: 'portfolio',
                                            Portfolios: 'Portfolios'
                                        };
                                        // Listen for terminology response
                                        scope.$on('terminology:response', function (event, terminology) {
                                            scope.terminology = terminology;
                                        });
                                        // Request terminology from parent when component is ready
                                        scope.$emit('terminology:request');
                                        scope.$watch('schemaName', function (newVal) {
                                            scope.schemaNameExists = false;
                                            if (newVal && newVal !== scope.originalSchemaName) {
                                                scope.schemaNameExists = scope.allSchemaNames.indexOf(newVal) >= 0;
                                            }
                                        }, true);
                                        scope.funcs = {
                                            initData: function () {
                                                scope.enableSaveSchema = false;
                                                scope.schemaErrors = {};
                                                scope.templateInfo = {
                                                    templateName: undefined,
                                                    platformOrLeaf: "leaf"
                                                };
                                                scope.loadedTemplate = undefined;
                                                scope.fieldList = undefined;
                                                scope.selectorData = new schema_selector_1["default"].SchemaSelector();
                                                scope.userRoles = {
                                                    portfolioAdmin: true,
                                                    contributor: false,
                                                    observer: false
                                                };
                                                scope.categoryEditConfig = {
                                                    exist: false,
                                                    allowEdit: false
                                                };
                                                scope.schemaName = undefined;
                                                scope.originalSchemaName = undefined;
                                                scope.schemaNameExists = false;
                                            },
                                            loadTemplates: function (callback, newSchema) {
                                                if (newSchema === void 0) { newSchema = true; }
                                                // Get template info (descriptions and others)
                                                scope.smartorg.getAllTemplates(scope.currentTreeNode._id).then(function (res) {
                                                    scope.availableTemplates = [];
                                                    var tempsInTree = scope.currentTreeNode.getAllTemplates();
                                                    res.templates.forEach(function (temp) {
                                                        if (tempsInTree.indexOf(temp.name) >= 0) {
                                                            temp.selector = new schema_selector_1["default"].SchemaSelector();
                                                            scope.availableTemplates.push(temp);
                                                        }
                                                    });
                                                    if (!scope.availableTemplates.length) {
                                                        throw new Error("Template not found. Is this an empty tree?");
                                                    }
                                                    scope.funcs.selectTemplate(scope.availableTemplates[0]);
                                                    if (callback) {
                                                        callback();
                                                    }
                                                    if (scope.availableTemplates.length === 1 &&
                                                        !scope.availableTemplates[0].hasPlatform) {
                                                        scope.phases.disablePhase1();
                                                        if (newSchema) {
                                                            scope.phases.donePhase1();
                                                        }
                                                    }
                                                    $timeout();
                                                })["catch"](function (err) {
                                                    console.error(err);
                                                });
                                            },
                                            selectTemplate: function (template) {
                                                scope.selectedTemplate = template;
                                                scope.templateInfo.templateName = template.name;
                                                scope.selectorData = template.selector;
                                                $timeout();
                                            },
                                            loadFields: function (callback) {
                                                scope.schemaErrors.fieldListLoadError = false;
                                                // If template is not changed, don't reload.
                                                if ((scope.selectedTemplate && scope.selectedTemplate.loaded) ||
                                                    (scope.loadedTemplate &&
                                                        scope.loadedTemplate.templateName == scope.templateInfo.templateName &&
                                                        scope.loadedTemplate.platformOrLeaf == scope.templateInfo.platformOrLeaf)) {
                                                    if (callback) {
                                                        callback();
                                                    }
                                                    $timeout(function () {
                                                        scope.funcs.initListSelectors();
                                                    });
                                                    return;
                                                }
                                                scope.fieldList = undefined;
                                                scope.smartorg.getDisplayNameList(scope.templateInfo.templateName, scope.templateInfo.platformOrLeaf, scope.currentTreeNode._id).then(function (res) {
                                                    scope.selectedTemplate.loaded = true;
                                                    scope.loadedTemplate = {
                                                        templateName: scope.templateInfo.templateName,
                                                        platformOrLeaf: scope.templateInfo.platformOrLeaf
                                                    };
                                                    scope.fieldList = new schema_fieldlist_1["default"].FieldList(res);
                                                    scope.selectorData.loadData(res);
                                                    if (callback) {
                                                        callback();
                                                    }
                                                    $timeout(function () {
                                                        scope.$apply();
                                                        scope.funcs.initListSelectors();
                                                    });
                                                })["catch"](function (err) {
                                                    console.error(err);
                                                    scope.schemaErrors.fieldListLoadError = true;
                                                    scope.$apply();
                                                });
                                            },
                                            initListSelectors: function () {
                                                scope.selectorInits.initInputFields();
                                                scope.selectorInits.initOutputFields();
                                                var res = scope.fieldList.getFieldListData();
                                                if (res.tableInputs && res.tableInputs.length > 0) {
                                                    scope.selectorInits.initTableInputFields();
                                                }
                                                if (res.tableOutputs && res.tableOutputs.length > 0) {
                                                    scope.selectorInits.initTableOutputFields();
                                                }
                                                scope.selectorInits.initCategoriesFields();
                                            },
                                            selectInputTable: function () {
                                                $timeout(function () {
                                                    scope.selectorInits.initTableInputFields();
                                                });
                                            },
                                            selectOutputTable: function () {
                                                $timeout(function () {
                                                    scope.selectorInits.initTableOutputFields();
                                                });
                                            },
                                            createSchema: function () {
                                                var templateName = scope.templateInfo.templateName;
                                                var templateType = scope.templateInfo.platformOrLeaf;
                                                var sch = new schema_1["default"].UniversalSchema();
                                                if (scope.schemaName) {
                                                    sch.setId(scope.schemaName);
                                                }
                                                scope.availableTemplates.forEach(function (template) {
                                                    if (template.selector.checkFieldsStatus()) {
                                                        template.selector.updateSchema(sch, template.name, templateType);
                                                    }
                                                });
                                                scope.selectorData.updateSchema(sch, templateName, templateType);
                                                sch.setAccess(true, scope.userRoles.contributor, scope.categoryEditConfig.allowEdit, scope.userRoles.observer, undefined, undefined);
                                                return sch;
                                            },
                                            /**
                                             * Save schema to root node. If old name is provided,
                                             * rename schema.
                                             *
                                             * @param oldName {string} Seems to be name of
                                             *     current schema if loaded one.
                                             */
                                            saveSchema: function (oldName) {
                                                scope.smartorg.saveUnivSchemaToRoot(scope.currentTreeNode._id, scope.schema.getSchemaData(), oldName).then(function (res) {
                                                    if (res.status == 0) {
                                                        scope.$emit('workbench:alert', {
                                                            "type": "success",
                                                            "title": "Success!",
                                                            "message": res.message
                                                        });
                                                        var newName = res.schemaName;
                                                        scope.funcs.emitSchema();
                                                        scope.$emit('workbench:reloadroot', {
                                                            "schemaName": "UniversalIO:" + newName
                                                        });
                                                    }
                                                    else if (res.status < 0) {
                                                        scope.funcs.emitCancel();
                                                        scope.$emit('workbench:alert', {
                                                            "type": "info",
                                                            "title": "Notice!",
                                                            "message": res.message
                                                        });
                                                    }
                                                    else {
                                                        scope.funcs.emitCancel();
                                                        scope.$emit('workbench:alert', {
                                                            "type": "info",
                                                            "title": "Error!",
                                                            "message": res.message
                                                        });
                                                    }
                                                })["catch"](function (err) {
                                                    console.error(err);
                                                });
                                            },
                                            finishSchemaBuilding: function () {
                                                var oldSchemaName = scope.schema.getSchemaName();
                                                scope.schema = scope.funcs.createSchema();
                                                if (scope.enableSaveSchema && scope.schemaName &&
                                                    (scope.isAdmin || scope.isPortfolioAdmin)) {
                                                    scope.funcs.saveSchema(oldSchemaName);
                                                }
                                                else {
                                                    scope.funcs.emitSchema();
                                                }
                                            },
                                            emitSchema: function () {
                                                scope.$emit('universal.schema:done', {
                                                    "schema": scope.schema,
                                                    "fields": scope.fieldList,
                                                    "skipLoadTable": scope.enableSaveSchema &&
                                                        scope.schema.getSchemaName() && true
                                                });
                                            },
                                            emitCancel: function () {
                                                scope.$emit('universal.schema:cancel');
                                            },
                                            setCurrentTemplate: function () {
                                                var templateName = undefined;
                                                var leafOrPlatform = "leaf";
                                                var templatesInSchema = scope.schema.getSchemaData().templates;
                                                for (var temp in templatesInSchema) {
                                                    if (templatesInSchema.hasOwnProperty(temp)) {
                                                        templateName = temp;
                                                        if (templatesInSchema[templateName].platform) {
                                                            leafOrPlatform = "platform";
                                                        }
                                                        break;
                                                    }
                                                }
                                                return {
                                                    "templateName": templateName,
                                                    "platformOrLeaf": leafOrPlatform
                                                };
                                            },
                                            setCurrentFields: function () {
                                                if (!scope.templateInfo) {
                                                    return;
                                                }
                                                var templateData = scope.schema.getTemplateData(scope.templateInfo.templateName, scope.templateInfo.platformOrLeaf);
                                                scope.selectorData.setCurrentStatus(templateData);
                                                // scope.$emit('universal.schema:done', {
                                                //     "schema": scope.schema,
                                                //     "fields": scope.fieldList
                                                // });
                                            },
                                            setCurrentAccess: function () {
                                                var accessInSchema = scope.schema.getSchemaData().access;
                                                scope.userRoles = {
                                                    portfolioAdmin: accessInSchema.portfolioAdmin,
                                                    contributor: accessInSchema.contributor,
                                                    observer: accessInSchema.observer
                                                };
                                                scope.categoryEditConfig.allowEdit = accessInSchema.cateContributor;
                                            },
                                            /**
                                             * Load schema if schema exists.
                                             */
                                            loadSchema: function () {
                                                scope.funcs.loadTemplates(function () {
                                                    var nodeId = scope.currentTreeNode._id;
                                                    var schema = scope.schema;
                                                    var templatesInSchema = schema.getSchemaData().templates;
                                                    scope.funcs.setCurrentAccess();
                                                    if (scope.isAdmin || scope.isPortfolioAdmin) {
                                                        scope.enableSaveSchema = true;
                                                    }
                                                    scope.schemaName = scope.schema.getSchemaName();
                                                    scope.originalSchemaName = angular.copy(scope.schemaName);
                                                    scope.availableTemplates.forEach(function (template) {
                                                        var t = templatesInSchema[template.name];
                                                        var leafOrPlatform = t && t.platform ? 'platform' : 'leaf';
                                                        loadFields(nodeId, template, leafOrPlatform, schema);
                                                    });
                                                }, false);
                                            }
                                        };
                                        function loadFields(nodeId, template, leafOrPlatform, schema) {
                                            scope.smartorg.getDisplayNameList(template.name, leafOrPlatform, nodeId).then(function (res) {
                                                template.loaded = true;
                                                template.selector.loadData(res);
                                                scope.fieldList = new schema_fieldlist_1["default"].FieldList(res);
                                                var templateData = schema.getTemplateData(template.name, leafOrPlatform);
                                                template.selector.setCurrentStatus(templateData);
                                                $timeout(function () {
                                                    scope.$apply();
                                                    scope.funcs.initListSelectors();
                                                });
                                            })["catch"](function (err) {
                                                console.error(err);
                                                $timeout();
                                            });
                                        }
                                        /**
                                         * Handle which function to call in each phases.
                                         * Phase 1: Show list of templates and let user select
                                         *     one of the templates, including platform.
                                         * Phase 2: Show all avaliable fields in each category.
                                         *     Including input, output, table input and table
                                         *     output. User must choose at least one field to
                                         *     continue.
                                         * Phase 3: Show which node and what type of node this
                                         *     schema applys to, and show user roles selection.
                                         * Phase 4: Final review and save schema.
                                         * Phase 5: Emit schema to upper level for further
                                         *     operations.
                                         *
                                         * @type {*}
                                         */
                                        scope.phases = {
                                            currentPhase: 0,
                                            phase1Disabled: false,
                                            /**
                                             * Set current phase to a phase. Will trigger
                                             * display to update.
                                             *
                                             * @param p {number} Phase number, from 1 to 5.
                                             */
                                            setPhase: function (p) {
                                                scope.phases.currentPhase = p;
                                                if (p == 1 && scope.schemaErrors.fieldListLoadError == true) {
                                                    scope.schema.loadData(scope.unformattedSchema);
                                                    scope.funcs.loadSchema();
                                                }
                                            },
                                            /**
                                             * Phase 1 start, load templates.
                                             */
                                            initPhase1: function () {
                                                scope.phases.setPhase(1);
                                                scope.funcs.loadTemplates();
                                            },
                                            disablePhase1: function () {
                                                scope.phases.setPhase(2);
                                                scope.phases.phase1Disabled = true;
                                            },
                                            donePhase1: function () {
                                                scope.phases.initPhase2();
                                            },
                                            /**
                                             * Phase 2 start, load fields by template.
                                             */
                                            initPhase2: function () {
                                                scope.phases.setPhase(2);
                                                scope.funcs.loadFields();
                                            },
                                            /**
                                             * If user has selected at least one field, end
                                             * phase 2. Otherwise prompt user.
                                             */
                                            donePhase2: function () {
                                                if (scope.selectorData.checkFieldsStatus()) {
                                                    scope.categoryEditConfig.exist = (scope.selectorData.categoriesData.chosen.length > 0);
                                                    scope.phases.initPhase3();
                                                }
                                                else {
                                                    alert("Please select at least one field.");
                                                }
                                            },
                                            initPhase3: function () {
                                                scope.phases.setPhase(3);
                                            },
                                            donePhase3: function () {
                                                scope.availableTemplates.forEach(function (template) {
                                                    template.selector.checkFieldsStatus();
                                                });
                                                scope.phases.initPhase4();
                                            },
                                            initPhase4: function () {
                                                scope.phases.setPhase(4);
                                            },
                                            /**
                                             * All necessary information have been collected.
                                             * Generate schema and emit.
                                             */
                                            allDone: function () {
                                                scope.phases.setPhase(4);
                                                scope.funcs.finishSchemaBuilding();
                                            },
                                            cancel: function () {
                                                scope.funcs.emitCancel();
                                            }
                                        };
                                        scope.$on('universal.schema:init', function (event, args) {
                                            scope.currentTreeNode = args.selectedTreeNode.getRootNode();
                                            scope.isAdmin = args.isAdmin;
                                            scope.isPortfolioAdmin = args.isPortfolioAdmin;
                                            scope.allSchemaNames = scope.currentTreeNode.getSchemaNames();
                                            scope.unformattedSchema = args.schema;
                                            // Init schema object. This object contains all
                                            // necessary information for schema.
                                            scope.phases.currentPhase = 1;
                                            if (scope.unformattedSchema) {
                                                scope.schema = new schema_1["default"].UniversalSchema();
                                                scope.schema.loadData(scope.unformattedSchema);
                                                scope.funcs.loadSchema();
                                            }
                                            else {
                                                scope.schema = new schema_1["default"].UniversalSchema();
                                                scope.funcs.initData();
                                                scope.phases.initPhase1();
                                            }
                                        });
                                        scope.funcs.initData();
                                    }
                                };
                            }]);
                    })(plumbing = schema_2.plumbing || (schema_2.plumbing = {}));
                })(schema = universal.schema || (universal.schema = {}));
            })(universal = acts.universal || (acts.universal = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
//# sourceMappingURL=schema-builder-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/plumbing/schema-builder-directive.js